import { render } from "./TextDemo.vue?vue&type=template&id=7a583ede&scoped=true"
const script = {}

import "./TextDemo.vue?vue&type=style&index=0&id=7a583ede&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a583ede"]])

export default __exports__